import PropTypes from 'prop-types';
import React from 'react';
import { EmitMetric } from '../../Analytics/VisibilityPixel/VisibilityPixel';
import EditorialCard from '../../Community/EditorialCard/EditorialCard';
import CommonCardShell from '../../Layout/CommonCardShell/CommonCardShell';
import ListSection from '../../Layout/ListSection/ListSection';

import './TrendingContentBox.scss';

export default class TrendingContentBox extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        trendingArticles: PropTypes.arrayOf(
            PropTypes.shape({
                contentImage: PropTypes.shape({
                    src: PropTypes.string,
                    alt: PropTypes.string,
                }).isRequired,
                title: PropTypes.string.isRequired,
                contentUrl: PropTypes.string.isRequired,
            })
        ),
    };

    static defaultProps = {
        trendingArticles: [],
    };

    handleClick = () =>
        EmitMetric({
            misc_event_count: 1,
            misc_event_type: 'right-rail-trending-content-click',
        });

    render() {
        const { trendingArticles } = this.props;
        return (
            <CommonCardShell>
                <div className="component-RightRail-TrendingContentBox">
                    <ListSection title={'Recent Content'}>
                        {trendingArticles.map((article, idx) => (
                            <div
                                className="trending-content-box"
                                key={idx}
                                onClick={this.handleClick}
                            >
                                <EditorialCard
                                    className={'editorial-card'}
                                    image={article.contentImage.src}
                                    title={article.title}
                                    contentUrl={article.contentUrl}
                                    url={article.contentUrl}
                                    lazyLoadImages={true}
                                />
                            </div>
                        ))}
                    </ListSection>
                </div>
            </CommonCardShell>
        );
    }
}
